import { useState, useEffect } from 'react';
import { useLocation as useUnsafeLocation } from '@gatsbyjs/reach-router';
import { getConfiguration } from '../helpers/Configuration';

const DEFAULT_ORIGIN = process.env.DEPLOY_PRIME_URL || getConfiguration().channel.siteUrl;

export const useLocation = () => {
  const location = useUnsafeLocation();
  const [origin, setOrigin] = useState(DEFAULT_ORIGIN);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.origin) {
      setOrigin(window.location.origin);
    }
  }, []);

  return {
    ...location,
    origin,
  };
};
